import { render, staticRenderFns } from "./PhotographyCastingSection.vue?vue&type=template&id=b34804ea"
import script from "./PhotographyCastingSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyCastingSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyCastingSection.vue?vue&type=style&index=0&id=b34804ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports